export const STATIC_NAV_LINKS = [
  { id: 'home', labelKey: 'com.tempedge.msg.public.nav.home', path: '/home' },
  { id: 'howitworks', labelKey: 'com.tempedge.msg.public.nav.howitworks', path: '/tutorials' }
];

export default STATIC_NAV_LINKS;
